import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../../shared/validators/customvalidators';
import { AccountService } from './../../../shared/services/auth';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './reset-pwd.component.html',
  standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  @ViewChild('newPassword')
  newPasswordInput;
  showTypingText = 'show typing';
  pageForm: UntypedFormGroup;

  isCheckingParameters = false;
  isResetingPassword = false;
  isResetComplete = false;

  feedbackMessages: any[] = [];
  successMessage = '';

  userEmail: string;
  resetPasswordToken: string;
  operationToken: string;
  parametersAreValid: boolean;

  private subs = new SubSink();
  private queryStringParams: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private _accountService: AccountService) {
  }

  ngOnInit() {
    this.queryStringParams = this.route
      .params
      .subscribe(params => {
        this.userEmail = params['email'];
        this.resetPasswordToken = params['resetPasswordToken'];
        // this.operationToken = params['operationToken'];
        // this.onInitResetPassword();
      });

    this.initForms();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.queryStringParams.unsubscribe();
  }

  private initForms() {
    this.pageForm = new UntypedFormGroup({
      email: new UntypedFormControl(),
      newPassword: new UntypedFormControl(),
      confirmPassword: new UntypedFormControl()
    });

    const email = this.pageForm.controls['email'];
    const newPassword = this.pageForm.controls['newPassword'];
    const confirmPassword = this.pageForm.controls['confirmPassword'];

    email.setValidators(Validators.compose([
      Validators.required,
      CustomValidators.emailValidator,
      Validators.maxLength(50)
    ]));

    newPassword.setValidators(Validators.compose([
      Validators.required,
      CustomValidators.passwordPolicy(newPassword)
    ]));

    confirmPassword.setValidators(Validators.compose([
      Validators.required,
      CustomValidators.equal(newPassword)
    ]));

    newPassword.valueChanges.subscribe(() => confirmPassword.updateValueAndValidity());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showCurrentPassword(e) {
    const inputType =
            this.newPasswordInput.nativeElement.type;

    if (inputType === 'password') {
      this.newPasswordInput.nativeElement.type = 'text';
      this.showTypingText = 'hide typing';
    } else {
      this.newPasswordInput.nativeElement.type = 'password';
      this.showTypingText = 'show typing';
    }
  }

  onResetPassword() {
    this.isResetingPassword = true;
    this.isResetComplete = false;
    this.subs.sink = this.resetPassword()
      .subscribe(() => {
        // this.goToSignIn();
        this.successMessage = 'Your password has been reset';
        this.isResetingPassword = false;
        this.isResetComplete = true;
      },
      (error) => this.handleError(error));
  }

  resetPassword() {
    this.successMessage = '';
    this.feedbackMessages = [];

    const payload = {
      email: this.pageForm.value.email,
      newPassword: this.pageForm.value.newPassword,
      confirmPassword: this.pageForm.value.confirmPassword,
      resetPasswordToken: this.resetPasswordToken
    };

    return this._accountService.resetPassword(payload);
  }

  private handleError(errors) {
    this.isResetingPassword = false;
    this.isCheckingParameters = false;
    this.feedbackMessages = errors;

    this.goToMain();
  }

  private goToSignIn() {
    this.router.navigate(['signin']);
  }

  private goToMain() {
    this.router.navigate(['useraccount/user/properties']);
  }
}
